import { PayloadAction } from '@reduxjs/toolkit';
import { ContentReducerCreator } from '../types';

const setSearchReducer = (create: ContentReducerCreator) => {
  return create.reducer((state, action: PayloadAction<string>) => {
    state.search = action.payload;
    state.pageNumber = 1;
  });
};

export default setSearchReducer;
